import { Navigate, Route, Routes } from 'react-router-dom';

import { AsideMenu, Header } from '../../components';
import { FiltersContextProvider } from '../../services/contexts/FiltersContext';
import { UserDocumentContextProvider } from '../../services/contexts/UserDocumentContext';
import {
  Contato,
  Extrato,
  Dashboard,
  Pagamentos,
  RelatorioMovimentacao,
  RelatorioPagamento,
  Pessoas,
  Vendas,
  DetalheExtrato,
  Acompanhamento,
} from './pages';
import { Exportacoes } from './pages/Exportacoes';
import { Baixas } from './pages/Relatorios/Baixas';
import { TransacoesParcelas } from './pages/TransacoesParcelas';
import { Container } from './styles';
import { Antecipacao } from './pages/Antecipacao';

export const Admin = () => (
  <UserDocumentContextProvider>
    <FiltersContextProvider>
      <Container>
        <AsideMenu />
        <div className="contentContainer">
          <Header />
          <div className="dashboardContent">
            <div>
              <Routes>
                <Route path="dashboard" element={<Dashboard />} />
                <Route path="extrato" element={<Extrato />} />
                <Route path="extrato/:docto/:id" element={<DetalheExtrato />} />

                <Route path="antecipacao" element={<Antecipacao />} />
                <Route path="acompanhamento" element={<Acompanhamento />} />

                <Route
                  path="relatorio-movimentacao/:id/:pagamento"
                  element={<RelatorioMovimentacao />}
                />
                <Route path="baixas/:id" element={<Baixas />} />
                <Route
                  path="relatorio-pagamento"
                  element={<RelatorioPagamento />}
                />
                <Route path="contato" element={<Contato />} />
                <Route path="vendas" element={<Vendas />} />
                <Route path="pagamentos" element={<Pagamentos />} />
                <Route path="pessoas" element={<Pessoas />} />
                <Route path="exportacoes" element={<Exportacoes />} />
                <Route
                  path="transacoes-parcelas"
                  element={<TransacoesParcelas />}
                />
                <Route path="*" element={<Navigate to="/admin/dashboard" />} />
              </Routes>
            </div>
          </div>
        </div>
      </Container>
    </FiltersContextProvider>
  </UserDocumentContextProvider>
);
